import DataSource from '@glittr/frontend-core/src/core/v2/data/data-source';
import Vue from 'vue';
import PutFeedbackRequestModel from '../../../../../../services/v2/model/put-feedback-request-model';
import editFeedbackVueSchema from './edit.vue.schema';
import LookupRequestModel from '../../../../../../services/v2/model/lookup-request-model';
import GetFeedbackByCompanyIdRequestModel from '../../../../../../services/v2/model/get-feedback-by-company-id-request-model';
import EventPageBase from '../../../../_base/EventPageBase';
import GuidEventLookupModel from '../../../../../../services/v2/model/guid-event-lookup-model';

export default class EditPage extends EventPageBase {
  public editFeedbackModel: PutFeedbackRequestModel = new PutFeedbackRequestModel();

  public Id: number | undefined = undefined;

  public error?: Error | string = undefined;

  public isLoading = false;

  public isLoadingButton = false;

  public eventItems: GuidEventLookupModel[] | undefined;

  public get companyId() { return this.companiesDataSource.data?.data.id; }

  public isFeedbackEnabled: boolean | undefined = undefined;

  public editFeedbackDataSource = new DataSource({
    selectCommand: () => {
      const request = new GetFeedbackByCompanyIdRequestModel();
      request.eventIdentifier = this.eventsDataSource.filter.eventIdentifier;
      request.companyId = this.companyId;
      return Vue.$service.v2.api.tdg_Feedbacks.getFeedbackByCompanyId(request);
    },
    updateCommand: Vue.$service.v2.api.tdg_Feedbacks.putFeedback,
  });

  public companiesDataSource = new DataSource({
    selectCommand: Vue.$service.v2.api.tdg_Companies.getCompanyForUser,
  });

  public eventsDataSource = new DataSource({
    selectCommand: () => {
      const req = new LookupRequestModel();
      return Vue.$service.v2.api.tdg_Events.eventLookup(req);
    },
  });

  async initialize(): Promise<void> {
    await this.eventsDataSource.select();
    await this.loadEventLookup();
    await this.loadCompanyDataSource();
    this.editFeedbackDataSource.filter.companyId = this.companyId;
    await this.editFeedbackDataSource.select();

    if (this.editFeedbackDataSource.data?.items?.length! > 0) {
      const feedbackData = this.editFeedbackDataSource.data!.items[0].data;
      this.editFeedbackModel = feedbackData;

      this.Id = feedbackData.id;
      this.editFeedbackModel.id = this.Id;
    } else {
      Vue.$router.push('/tourdegwaerb/company/feedbacks/create');
      Vue.$log.warning('Keine Feedback-Daten gefunden.');
    }
    this.isLoadingButton = false;
    this.isLoading = false;
  }

  async editFeedback() {
    this.isLoadingButton = true;
    const valid = this.editFeedbackModel.validateWithSchema(editFeedbackVueSchema);
    if (valid) {
      if (!this.editFeedbackModel) {
        this.editFeedbackModel = new PutFeedbackRequestModel();
      }
      this.editFeedbackModel!.companyId = this.companyId;
      try {
        await this.editFeedbackDataSource.update(this.editFeedbackModel!);
        this.isLoading = true;
        this.isLoadingButton = false;
        Vue.$router.back();
      } catch (error: any) {
        Vue.$log.error(error);
        this.error = error;
      }
    }
  }

  async loadEventLookup() {
    if (this.eventsDataSource.data) {
      const res = this.eventsDataSource.data;

      this.eventItems = res.items.map((i) => {
        const model = new GuidEventLookupModel();
        model.id = i.data.id;
        model.caption = i.data.caption;
        model.isFeedbackEnabled = i.data.isFeedbackEnabled;

        return model;
      });

      if (this.eventItems.length > 0) {
        const lastItem = this.eventItems[this.eventItems.length - 1];
        this.eventsDataSource.filter.eventIdentifier = lastItem.id;
        this.isFeedbackEnabled = lastItem.isFeedbackEnabled;
      }
    }
  }
}
